// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OutOfStockActions_wrapper__CM_8O"};